import { render, staticRenderFns } from "./Go.vue?vue&type=template&id=3ece160b&scoped=true&"
import script from "./Go.vue?vue&type=script&lang=js&"
export * from "./Go.vue?vue&type=script&lang=js&"
import style0 from "./Go.vue?vue&type=style&index=0&id=3ece160b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ece160b",
  null
  
)

export default component.exports